<template>
	<div>中医医疗</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>